import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { MprcDialogTitleClose, MprcSpinnerIndicator } from "components";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { CustomVideoSlide } from "components/types/lightBox";
import { ShortVideoDto } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { BuildLighboxSlide } from "views/knowledge/components/card/behaviors/common/CardLightbox";
import { ShortVideoPlayer } from "views/knowledge/shorts/components/ShortVideoPlayer";

////////////////////////////////////////////////////////////////////////////////

interface IPreviewVideoDialogProps {
    shortVideoId: string;
    title: string;
    onClose: () => void;
}

export const PreviewShortVideoDialog = (props: IPreviewVideoDialogProps) => {
    const { shortVideoId, title, onClose } = props;

    const api = useCoreApi();
    const { t } = useTranslation("knowledge");

    const [video, setVideo] = useState<ShortVideoDto>(undefined!);
    const [loading, setLoading] = useState<boolean>(true);
    const slide = useRef<CustomVideoSlide | undefined>(undefined);

    ////////////////////////////////////////////////////////////////////////////
    /// EFFECT's
    ////////////////////////////////////////////////////////////////////////////

    ///
    useEffect(() => {
        async function load() {
            try {
                const result = await api.v1.knowledgeShortVideo.getShortVideo({ shortVideoId });
                const video = result.data;
                setVideo(video);
                slide.current = BuildLighboxSlide(video.attach, true) as CustomVideoSlide;
            }
            catch (error: any) {
                MprcRequestSnackbarErrorReport(error);
            }
            finally {
                setLoading(false);
            }
        }

        load();
    }, []);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <Dialog
            open
            maxWidth="md"
            fullWidth
        >
            <MprcDialogTitleClose
                title={t("ShortVideo.PreviewShortVideoDialog.Title")}
                subtitle={title}
                onClose={() => onClose()}
                shrinkPadding
            />

            <DialogContent>

                {
                    loading
                        ? <MprcSpinnerIndicator />
                        : <ShortVideoPlayer
                            {...slide.current!}
                            editMode={false}
                            height={400}
                            startTime={video.settings?.startTime}
                            endTime={video.settings?.endTime}
                            onEnded={() => onClose()}
                        />

                }

            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
};
